<template>
  <div>
    <div>
      <p v-html="question?.question"></p>
    </div>
    <div v-if="question?.image" class="mb-5">
      <el-image
          :key="question.image"
          style="width: 100px; height: 100px"
          :src="question.image"
          :preview-src-list="[question.image]">
      </el-image>
    </div>
    <div style="display: flex; align-items: center; gap: 10px">
      <span style="font-weight: 700">Bài làm của học viên</span>
      <span v-if="wordCount > 0" style="background-color: #409EFF; color: white; padding: 2px 8px; border-radius: 10px; font-size: 12px; font-weight: 600">
        {{ wordCount }} từ
      </span>
    </div>
    <hr class="block my-3" />
    <div style="background: #F8F8F8; padding: 14px 10px">
      <div v-if="answerImages.length" style="border-radius: 5px; padding: 14px 10px; background: white; max-height: 300px" class="overflow-auto mt-4">
        <div style="display:flex; justify-content: center">
          <el-carousel :interval="4000" type="card" height="200px" style="width: 100%">
            <el-carousel-item v-for="item in answerImages" :key="item">
              <el-image style="height: 300px" :src="item" :fit="fill"
                :preview-src-list="answerImages">
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div v-if="answerTexts.length" style="margin-top: 10px">
        <div v-for="(answer, index) in answerTexts" :key="index">{{ answer }}</div>
      </div>
      <div v-if="!answerImages.length && !answerTexts.length" style="margin-top: 10px">
        Chưa có bài
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudentAnswer',
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    answers() {
      const answer = this.question?.answer
      return (Array.isArray(answer) ? answer : [answer])
        .filter(item => typeof item === 'string' && item.trim())
        .map(item => item.trim())
    },
    answerImages() {
      return this.answers.filter(item => this.isImageAnswer(item))
    },
    answerTexts() {
      return this.answers.filter(item => !this.isImageAnswer(item))
    },
    answerText() {
      return this.answerTexts.join(' ').replace(/<[^>]*>/g, '').trim()
    },
    wordCount() {
      if (!this.answerText) return 0
      return this.answerText.split(/\s+/).filter(w => w.length > 0).length
    }
  },
  methods: {
    isImageAnswer(value) {
      return /^(?:(?:https?:)?\/\/|data:image\/|blob:)\S+$/i.test(value) || /\.(?:jpe?g|png|gif|webp|bmp|svg)(?:\?.*)?$/i.test(value)
    }
  }
}
</script>

